// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"issuesModal_wrapper_29C4c0m"};